import { render, staticRenderFns } from "./GraphicDetails.vue?vue&type=template&id=cb00b788&scoped=true"
import script from "./GraphicDetails.vue?vue&type=script&lang=js"
export * from "./GraphicDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb00b788",
  null
  
)

export default component.exports